import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { OPENING_HOURS, SERVICE_MENUS } from '../data/locations';
import { SectionHeading } from './SectionHeading';
type PricingMenusProps = {
  headingId?: string;
};
export function PricingMenus({
  headingId = 'pricing-heading'
}: PricingMenusProps) {
  return <div className="rounded-2xl border border-white/5 bg-ink-900/70 p-8 sm:p-14" data-id="element-101" data-mp="2fyxt5kpetyfj">
      <SectionHeading id={headingId} eyebrow="The Menu" title="Our Services" subtitle="Therapists trained across East and Southeast Asia, at every studio." data-id="element-102" data-mp="2tyfm8c9qnxup" />

      <div className="mt-14 grid gap-6 lg:grid-cols-2" data-id="element-103" data-mp="33oifmdkrvdtk">
        {SERVICE_MENUS.map((menu, i) => <motion.section key={menu.name} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.45,
        delay: i * 0.08,
        ease: 'easeOut'
      }} aria-label={menu.name} className="rounded-xl border border-white/5 bg-ink-850/80 p-8 transition-colors hover:border-lotus-500/30" data-id="element-104" data-mp="2yr8qz057j66s" data-mpi={i}>
            <h3 className="font-display text-3xl font-light tracking-wide text-white" data-id="element-105" data-mp="2brxtqpgujjl8">
              {menu.name}
            </h3>
            <p className="mt-3 text-sm font-light leading-relaxed text-neutral-400" data-id="element-106" data-mp="2grap5yls9yzf">
              {menu.description}
            </p>
            <ul className="mt-7 divide-y divide-white/5" data-id="element-107" data-mp="2kscgzuddf8rd">
              {menu.tiers.map(tier => <li key={tier.duration} className="flex items-baseline justify-between gap-4 py-4" data-id="element-108" data-mp="2ppw83uv63g0q">
                  <span className="text-sm font-light uppercase tracking-[0.16em] text-neutral-300" data-id="element-109" data-mp="2uj7clpcibkph">
                    {tier.duration}
                  </span>
                  <span className="font-display text-3xl font-light text-lotus-500" data-id="element-110" data-mp="34hmvx65alpof">
                    {tier.price}
                  </span>
                </li>)}
            </ul>
          </motion.section>)}
      </div>

      <aside className="mx-auto mt-8 flex max-w-2xl items-start gap-4 rounded-xl border border-[#A855F7]/40 bg-[#A855F7]/[0.09] p-6 text-left" data-id="element-111" data-mp="19bcgjnua41ec">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#A855F7]/20 text-[#D8B4FE]" data-id="element-112" data-mp="1i60k99k7hb11">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="1ddh72dpfkhwr" />
        </span>
        <p className="text-sm font-light leading-relaxed text-neutral-300" data-id="element-114" data-mp="1s2vgtmwx51co">
          <span className="font-medium text-[#D8B4FE]" data-id="element-115" data-mp="1n53myncpr55u">Additional services available.</span> Extras
          can be arranged on request and discussed discreetly with your therapist at the venue.
          Strictly ages 18+.
        </p>
      </aside>

      <p className="mt-8 text-center text-sm font-light tracking-wide text-neutral-500" data-id="element-116" data-mp="1x3j9se4pjs9j">
        All studios open{' '}
        <span className="text-lotus-500" data-id="element-117" data-mp="6sewnstzvhhm">{OPENING_HOURS}</span>
      </p>
    </div>;
}